<template>
    <div>
        <HeaderSection icon="far fa-config" title="Títulos y descripciones">
            <template slot="buttons">
                <el-button
                    size="medium"
                    type="danger"
                    icon="el-icon-arrow-left"
                    @click="goToBack">
                    Regresar
                </el-button>
            </template>
        </HeaderSection>

        <br>


        <el-form ref="form" :model="form" label-width="120px" label-position="top">

            <el-row :gutter="20">
                <el-col :span="24">
                    <el-form-item  label="Categoría o Tipo de Trámite">
                        <el-select
                            @change="filterCategory(form.category)"
                            v-model="form.category"
                            style="width: 100%"
                            placeholder="Seleccionar">
                            <el-option
                                v-for="item in categories"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>


                </el-col>
            </el-row>
            <el-row :gutter="20" v-if="showData">
                <el-col :span="12">
                    <el-form-item label="Título"
                                  prop="name"
                                  :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }">
                        <el-input v-my-only-alphanumeric="{maxChars: 70}" :rows="4" resize="none" type="textarea" v-model="form.name"/>
                    </el-form-item>

                </el-col>
                <el-col :span="12">
                    <el-form-item label="Descripción"
                                  prop="description"
                                  :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }">
                        <el-input v-my-only-alphanumeric="{maxChars: 70}" :rows="10" resize="none" type="textarea" v-model="form.description"/>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <br>
        <el-row type="flex" v-if="showData">
            <el-col align="end">
                <el-button icon="far fa-save" type="success" @click="updateForm">
                    Guardar
                </el-button>
            </el-col>

        </el-row>



    </div>
</template>

<script>
    import HeaderSection from "../../../partials/HeaderSection";

    export default {
        components:{
            HeaderSection
        },

        mounted(){

        },

        data(){
            return{
                form: {},
                categories:[
                    {
                        id: 4,
                        name: 'Sistema'
                    },
                    {
                        id: 1,
                        name: 'Adquisiciones'
                    },
                    {
                        id: 2,
                        name: 'Fideicomisos'
                    },
                    {
                        id: 3,
                        name: 'Convenios de Extranjería'
                    },

                ],
                showData: false
            }
        },

        methods:{
            goToBack(){
                this.$router.push('/administracion');
            },

            updateForm(){
                this.$refs['form'].validate((valid) => {
                    if (valid) {

                        axios.post('/api/update-category-utils', this.form).then(response => {
                            this.$notify({
                                type: 'success',
                                title: 'Éxito',
                                message: response.data.message
                            });

                        }).catch(error => {

                            this.$notify({
                                type: 'error',
                                title: 'Error',
                                message: 'No fue posible registrar al usuario, inténtelo nuevamente otra.'
                            });
                        });

                    } else {
                        this.$notify({
                            type: 'warning',
                            title: 'Campos Requeridos',
                            message: 'Por favor complete todos los campos requeridos.'
                        });

                        return false;
                    }
                });
            },

            filterCategory(category){
                if(category && category != null){
                    axios.get('/api/get-category-utils',{params:
                            {
                                category: category
                            }
                    }).then(response => {
                        if(response.data.success){
                            this.showData = true;
                            this.form = response.data.category
                        }
                    })
                }
            }
        },


    }
</script>

<style scoped>

</style>
